<template>
  <div id="app" >
    <div class="layout">
      <div class="headers">
        <div class="header mobile" v-if="loaded">
          <img :src="data.header.left" alt="">
        </div>
        <div class="header mobile" v-if="loaded">
          <img :src="data.header.right" alt="">
        </div>
      </div>

      <!-- <div class="debug">
        <span class="reload" v-on:click="reloadDefault()">↻ Default</span> <a href="/default.json" target="_blank">View</a>
        <span class="reload" v-on:click="reloadProxy()">↻ Proxy</span> <a href="/proxy.php" target="_blank">View</a>
      </div>
       -->
      <main>
        <div class="open" @click="onOpenIndicators()" v-if="loaded">{{data.dictionary.openIndicators}}</div>
        <div class="inner">
          <div class="images" v-if="loaded">
            <images :images="filteredImages" :data="data"></images>
          </div>
        </div>
      </main>
      <div :class="{'indicators':true,'open':open}" v-if="loaded">
         <indicators :data="data" v-on:onClickedClose="onClickedClose" v-on:onSelectionChange="onSelectionChange"></indicators>
      </div>
    </div>
  </div>
</template>

<script>
import Indicators from './components/Indicators.vue';
import Images from './components/Images.vue';
import Toggle from './components/Toggle.vue';

export default {
  name: 'app',
  components: {
    indicators: Indicators,
    images: Images,
    toggle: Toggle
  },
  data() {
    return {
      data: {},
      loaded: false,
      open:false,
      filteredImages: {}
    }
  },
  mounted() {
      this.reloadDefault();
  },
  methods: {
    onOpenIndicators() {
      this.open = true;
    },
    onClickedClose() {
      this.open = false;
    },
    onSelectionChange(selectionData) {

      const filteredImages = {};

      const selectionDataIndicatorKeys = Object.keys(selectionData);
      
      //images
      
      
      for(const imageKey of Object.keys(this.data.images)) {
        const image = this.data.images[imageKey];
        
        let matches = false;
        const imageIndicatorKeys = Object.keys(image.indicators);

        //image indicators
        for(const imageIndicatorKey of imageIndicatorKeys) {

          //skip venues
          if(imageIndicatorKey !== 'venues') {
            //only indicators that has values
            if(!selectionData[imageIndicatorKey]) {
              continue;
            } 
            

            let imageIndicatorKeyValues = image.indicators[imageIndicatorKey];

  
            //image indicator values
            for(const val of imageIndicatorKeyValues) {
              
              
              
              if(selectionData[imageIndicatorKey][val]) {
                matches = true;
              } 
            }
          }
        }

        
        

        //venues
        
        
        //any venues selected?
        if(selectionData.venues) {
          let venuesSelected = image.venues;
  
          //image indicator values
          for(const val of venuesSelected) {
            if(selectionData.venues[val]) {
              matches = true;
            } 
          }
          
        } 

      
      
        if(matches) {
          filteredImages[imageKey] = image;
        }
      }

      this.filteredImages = filteredImages;

    },
    reloadDefault() {
      fetch('/default.json').then(response => {
        return response.json();
      }).then(rep => {
        this.data = rep.data;
        this.filteredImages = this.data.images;
        this.loaded = true;
        
      }).catch(err => {
        alert("ERR default: " + err);
      });   
    },
    isJSON(str) {
      return true;
      try {
          JSON.parse(str);
      } catch (e) {
          return false;
      }
      return true;
    },
    reloadProxy() {
      fetch('/proxy.php').then(response => {
        if(this.isJSON(response)) {
          return response.json();
        } else {
          alert('Not valid JSON, try validate');
          return 0;
        }
        
      }).then(rep => {
        if(rep) {
          this.data = rep.data;
          this.filteredImages = this.data.images;
          this.loaded = true;
          // this.onDataLoaded();
        }
      }).catch(err => {
        alert('ERR '+err);
      });   
    } 
  }
}
</script>

<style lang="scss">
  @import 'global';
  @import '~mapbox-gl/dist/mapbox-gl.css';

  .debug {
    position:fixed;
    bottom:0;
    left:0;
    z-index: 2;
    padding:0.25rem;
    margin:1rem;
    background-color: white;
  }
  .reload {
    cursor: pointer;
  }
  .headers {
    display:none;
    @media (max-width:979px) {
      padding:0.75rem;
      display:block;
      .header {
        width:calc(100% - 2rem) !important;
        img {
          width:100%;
        }
      }
    }

    .header {
      width:calc(50vw - 3rem);
      img {
        width: 100%;
        height:auto;
      }
      &.mobile {
        
        display: none;
        @media (max-width:979px) {
          display:block;
        }
      }
    }
  }
  .layout {
    // grid-gap: 0.5rem;
    // margin: 0.75rem;
    height:100vh;
    width:100%;
    overflow:hidden;

    position: absolute;

    main {
      position:relative;
      overflow-y:scroll;
      
      height:100vh;
      .open {
        display:none;
      }
      .inner {
        padding:0.75rem;
      }
    }
    @media #{$medium-up} {
      display:grid;
      grid-template-columns: 50% 50%;
      .indicators {
        grid-column: 2 / 3;
        grid-row: 1 / span 2;
      }
    }
    @media #{$small-down} {
      main {
        padding-right: 1.5rem;
        .open {
          display:block;
          
          position:fixed;
          top:-2.2rem;
          box-shadow: 0 0 3rem rgba(0,0,0,0.25);
          right:0;
          transform-origin:  100% 100%;
          transform:rotate(-90deg);

          // text-transform: uppercase;
          padding:0.5rem;
          z-index:2;
          background-color:white;
          width:110vh;
          text-align:right;


          // padding:1px 4px ;
          // margin-right:1rem;
          font-weight:bold;
          border-radius:3px;
          letter-spacing: 0.05em;

          cursor:pointer;

        }
      }
      .indicators {
        transition: transform 0.2s ease;
        transform: translate3d(100%,0,0);
        max-width: 100%;

        &.open {
          transform: translate3d(0%,0,0);
        }
        
        z-index: 2;
        position:absolute;
        top:0;
        right:0;
        height:100vh;
        
      }
    }
  }
</style>
